import { render, staticRenderFns } from "./AClock.vue?vue&type=template&id=af7ea38c&scoped=true"
import script from "./AClock.vue?vue&type=script&lang=js"
export * from "./AClock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af7ea38c",
  null
  
)

export default component.exports